import React from "react";
import { productImages } from "../lib/productImages";

export const ProductImage = ({
  imageKey,
  alt,
  sizes,
  loading = "lazy",
  fetchPriority = "auto",
  className = "",
  testId,
}) => {
  const image = productImages[imageKey];

  if (!image) {
    return null;
  }

  return (
    <picture className="block w-full">
      <source type="image/webp" srcSet={image.webpSrcSet} sizes={sizes} />
      <img
        src={image.fallback}
        srcSet={image.jpgSrcSet}
        sizes={sizes}
        alt={alt || image.alt}
        width={image.width}
        height={image.height}
        loading={loading}
        decoding={loading === "eager" ? "sync" : "async"}
        fetchPriority={fetchPriority}
        draggable="false"
        data-testid={testId}
        className={`block w-full h-auto object-contain object-center ${className}`.trim()}
      />
    </picture>
  );
};